// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 1.99951H23.0001L23.0001 18.9995L17.0355 18.9995L12.0001 13.9641L6.96495 18.9995L1.00112 18.9995L1 1.99951Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.2072 21.9997L6.79297 22L12.0001 16.7926L17.2072 21.9997Z"}}]};

const ScreencastFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'screencast-filled',
    ref,
    icon: element,
  },
));

ScreencastFilledIcon.displayName = 'ScreencastFilledIcon';

export default ScreencastFilledIcon;
